import React, {useEffect} from 'react';
import Card from '../../../componentes/contenedores/Card';
import Page from '../../../componentes/plantilla/Page';
import { useContextEmpleado } from '../../../contexto/empleado/EmpleadoContext';
import TablaClientes from './TablaEmpleados';
import { EmpleadosListar } from '../../../configuracion/apiUrls';

const HomeBuscarEmpleados = () => {
  const { listaEmpleados, ActualizarLista, setListaEmpleados } = useContextEmpleado();

  useEffect(() => {
                if (!Array.isArray(listaEmpleados) || listaEmpleados.length === 0) {
                    ActualizarLista(EmpleadosListar, setListaEmpleados);
                }
            }, [ActualizarLista, listaEmpleados, setListaEmpleados]);
    

  const datos = {
    titulo: {
      titulo: "Busqueda de empleados",
      url: "/app/admin/empleados/buscar",
      tituloUrl: "Empleados",
      nombreUrl: "Buscar"
    }
  }

  return (
    <Page datos={datos}>
      <Card titulo="Lista de Empleados">
        <TablaClientes datos={listaEmpleados}></TablaClientes>
      </Card>
    </Page>
  )
}

export default HomeBuscarEmpleados;